import type { AppFrameApi } from "./types";

const getWindowApi = () => (window as Window & { appFrameApi?: AppFrameApi }).appFrameApi;

export const getApi = (): AppFrameApi => {
  const api = getWindowApi();
  if (!api) {
    throw new Error("The App Frame API has not been initialized by the App Frame.");
  }
  return api;
};

export const getAppConfiguration = () => getApi().getAppConfiguration();
